import { notification } from 'antd'
import {getMonitoringSourceService} from '../services/GetMonitoringSourceService'

export const getSourcesSumaryPromise= (dataRange) => {
	return new Promise(resolve => {
		getMonitoringSourceService(dataRange)
			.then(response => resolve({ success: true, data: response.data }))
			.catch(error => {notification.error({message: "Alert Resume : "+error.message})})
	})
}

